var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input-post", {
        ref: "postInput",
        attrs: {
          hasActionButton: "",
          rich: "",
          editFields: _vm.getAdvertisable,
          type: _vm.getPostType
        },
        on: { fieldUpdate: _vm.fieldUpdate, updateValidity: _vm.updateValidity }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center mt-3", attrs: { id: "postUpdate" } },
        [
          _c("input-button", {
            attrs: {
              centered: "",
              inputPlaceholder: _vm.$t("Button.update"),
              variant: "standardInput",
              dissabled: !_vm.fieldsValid,
              btnStyle: "ok-style"
            },
            on: { click: _vm.updateAdvertisable }
          }),
          _vm._v(" "),
          !_vm.fieldsValid
            ? _c("b-tooltip", {
                attrs: {
                  target: "postUpdate",
                  container: "postUpdate",
                  title: _vm.$t("Post.warning")
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d00d0d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d00d0d9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/postManager/PostEditor.vue
// module id = null
// module chunks = 